const RE_PATH_TOKEN = /\{[\w-]+\}/g

export function createPath (
  firestorePath = '',
  params: Record<string, string | number> = {}
): string {
  const _path = firestorePath.replace(RE_PATH_TOKEN, (match) => {
    const key = match.replace(/[{}]/g, '')

    return `${(params || {})[key] || ''}`
  })

  return _path
}
